import type { IconSvgObject } from './types';

const Kurta01Icon: IconSvgObject = [
  ["path", { d: "M17.5488 15H19.8111C20.4319 15 20.9027 14.4403 20.7963 13.8287L19 3.5L14.5056 2C14.0044 3 13.0022 3.5 12 3.5C10.9978 3.5 9.99555 3 9.49444 2L5 3.5L3.20371 13.8287C3.09734 14.4403 3.56813 15 4.18892 15H6.45124M16 6.5L17.8545 20.872C17.9316 21.4702 17.4658 22 16.8627 22H7.13732C6.53423 22 6.06837 21.4702 6.14554 20.872L8 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 12H20.5M3.5 12H7", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 4L12 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Kurta01Icon;
